import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import supportersAvatar from './supportersAvatar';
import ab from './ab';
import friends from './friends';
import bank from './bank';
import create from './create';
import pageLink from './pageLink';
import story from './story';
import coverPhoto from './coverPhoto';
import coverPhotoEditorReducer from './photoEditor';
import page from './page';
import richUpdates from './richUpdates';
import supporters from './supporters';
import categories from './categories';
import sharePrompts from './sharePrompts';
import identityVerification from './identityVerification';
import addressVerification from './addressVerification';
import completedActions from './completedActions';
import self from './self';
import subscriptions from './subscriptions';
import paymentDetails from './paymentDetails';
import alternativeProjects from './alternativeProjects';
import censures from './censures';
import avatars from './avatars';
import home from './home';
import carousel from './carousel';
import dashboard from './dashboard';
import funds from './funds';
import asyncConnect from './asyncConnect';
import stripeVirtualAccount from './stripeVirtualAccount';
import settings from './settings';
import consents from './consents';
import charity from './charity';

const appReducer = combineReducers({
  ab,
  routing,
  form,
  page,
  create,
  coverPhoto,
  createCoverPhotoEditor: coverPhotoEditorReducer.bind(null, 'create'),
  editCoverPhotoEditor: coverPhotoEditorReducer.bind(null, 'edit'),
  editStripeVerificationDocument: coverPhotoEditorReducer.bind(
    null,
    'stripeVerification'
  ),
  story,
  payment: bank,
  pageLink,
  richUpdates,
  supporters,
  supportersAvatar,
  categories,
  identityVerification,
  addressVerification,
  sharePrompts,
  self,
  subscriptions,
  paymentDetails,
  alternativeProjects,
  friends,
  censures,
  avatars,
  home,
  carousel,
  completedActions,
  dashboard,
  funds,
  stripeVirtualAccount,
  asyncConnect,
  settings,
  consents,
  charity,
  // these reducers are needed so we can inject values into the store during
  // server-side rendering
  location: (s = {}) => s,
});

export default (state, action) => {
  if (action.type === 'DELETE_PAGE_SUCCESS') {
    return appReducer({ routing: state.routing }, action);
  }

  return appReducer(state, action);
};



// WEBPACK FOOTER //
// ./src/redux/modules/index.js